import { render, staticRenderFns } from "./H5.vue?vue&type=template&id=5d0d8b84&scoped=true&"
var script = {}
import style0 from "./H5.vue?vue&type=style&index=0&id=5d0d8b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0d8b84",
  null
  
)

export default component.exports